import moment from 'moment';
import angular from 'angular';

class MenuDiscountController {
    /* @ngInject */
  constructor($scope, $log, $rootScope, NewBackendService, MerchantConfigurationService, NewMerchantProfileService) {
    const that = this;

    const CHECK_IN = 0; // Servizio di check-in dei clienti presso lo store
    const ORDER_AND_PAY = 1; // Servizio di pagamento ordini da menu
    const TAXATION = 2; // Servizio di gestione della fiscalità con Tinaba

    that.dates = {
      today: moment()
    };

    let idMerchant;

    that.discountObj = {
      discount: {
        amount: null,
        description: '',
        enabled: false,
        endDate: null,
        levelBTemp: false,
        levelB: false,
        levelA: false,
        name: '',
        percentage: null,
        startDate: null,
        type: 'percentage'
      },
      loading: false,
    };

    that.discountCopy = {};

    this.save = () => {
      const req = {
        data: {
          request: {
            setMerchantDiscountRequest: {
              idAnagraficaMerchant: idMerchant,
              vasId: ORDER_AND_PAY,
              name: that.discountObj.discount.name,
              description: that.discountObj.discount.description,
              dataInizio: moment(that.discountObj.discount.startDate).format('YYYY-MM-DD'),
              dataFine: moment(that.discountObj.discount.endDate).format('YYYY-MM-DD'),
              levelBTemp: that.discountObj.discount.levelBTemp === true ? 1 : 0,
              levelB: that.discountObj.discount.levelB === true ? 1 : 0,
              levelA: that.discountObj.discount.levelA === true ? 1 : 0,
              enabled: that.discountObj.discount.enabled === true ? 1 : 0
            }
          }
        },
        userContext: {}
      };
      if (that.discountObj.discount.type === 'percentage') {
        req.data.request.setMerchantDiscountRequest.discountPercentage = that.discountObj.discount.percentage;
      } else {
        req.data.request.setMerchantDiscountRequest.discountAmount = that.discountObj.discount.amount;
      }
      NewBackendService.invokeWebApiPost('merchantCatering/setMerchantDiscount', req).then((r) => {
        $log.debug(r);
      }, reason => {
        $log.error('DiscountError', reason);
      });
    };

    this.reset = () => {
      that.discountObj.discount = angular.copy(that.discountReset);
    };

    const init = () => {
      that.discountObj.loading = true;
      NewMerchantProfileService.getMerchantProfile().then((r) => {
        idMerchant = r.idanagraficamerchant;
        if ('discounts' in r.merchantStoreExtended) {
          const discount = r.merchantStoreExtended.discounts[0];
          that.discountObj.discount = {
            amount: discount.discountAmount,
            description: discount.description,
            percentage: discount.discountPercentage,
            enabled: discount.enable === 1 ? true : false ,
            endDate: moment(discount.dataFine).format('YYYY-MM-DD'),
            levelBTemp: discount.levelBTemp === 1 ? true : false,
            levelB: discount.levelB === 1 ? true : false,
            levelA: discount.levelA === 1 ? true : false,
            name: discount.name,
            type: discount.type,
            startDate: moment(discount.dataInizio).format('YYYY-MM-DD'),
            vasId: discount.vasId
          };
          if (moment(discount.dataInizio).diff(moment(), 'days') < 0) {
            that.discountObj.discount.startDate = moment().format('YYYY-MM-DD');
          }
          that.discountReset = angular.copy(that.discountObj.discount);
        } else {
          that.userContext = r;
        }
        that.discountObj.loading = false;
      }, reason => {
        $log.error('DiscountError', reason);
      });
    };

    $scope.$watch(() => {
      return that.discountObj.discount.percentage;
    }, newVal => {
      if (newVal > 100) {
        if (that.discountReset.percentage) {
          that.discountObj.discount.percentage = that.discountReset.percentage;
        } else {
          that.discountObj.discount.percentage = 100;
        }
      }
    });

    that.$onInit = init;
  }
}

export default MenuDiscountController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/discount/discount.controller.js
 **/